export default __webpack_public_path__ + "assets/images/yali-74e18fbe3941f968b026d76f66d6addf.png";